module.exports = __webpack_public_path__ + "static/media/resume.18eb87f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/resume.svg
// module id = 1103
// module chunks = 0